<template>
  <div>
    <router-view></router-view>

    <van-tabbar v-model="active" active-color="rgb(255, 122, 0)"  inactive-color="rgb(156, 152, 145)" fixed placeholder route>
      <van-tabbar-item  to="/index">
        <span>Home</span>
        <template #icon="props">
          <img :src="props.active ? icon.active : icon.inactive" />
        </template>
      </van-tabbar-item>
      <van-tabbar-item  to="/cash">
        <span>Cash</span>
        <template #icon="props">
          <img :src="props.active ? icon2.active : icon2.inactive" />
        </template>
      </van-tabbar-item>
      <van-tabbar-item  to="/my">
        <span>My</span>
        <template #icon="props">
          <img :src="props.active ? icon3.active : icon3.inactive" />
        </template>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
export default {
  data() {
    return {
      active: 'index',
      icon: {
        active: 'https://imgs.hdjfg.com/gift/img/home_active.png',
        inactive: 'https://imgs.hdjfg.com/gift/img/home.png'
      },
      icon2: {
        active: 'https://imgs.hdjfg.com/gift/img/cash_active.png',
        inactive: 'http://imgs.hdjfg.com/gift/img/cash.png'
      },
      icon3: {
        active: 'https://imgs.hdjfg.com/gift/img/my_active.png',
        inactive: 'https://imgs.hdjfg.com/gift/img/my.png'
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.van-tabbar-item__icon img {
  height: 1.7rem;
}
</style>
